import React from 'react';
import { dark_close } from '../../assets/images';
import { dsButtonDisabledPrimary, dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';

const IntegrationSuccessModal = ({ visible, icon, heading, body, btnText, modelHeight = '20rem', btnHandler, disableBtn, handler }) => {
  return (
    <div
      className={`fixed z-30 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
      aria-labelledby='modal-title'
      role='dialog'
      aria-modal='true'
    >
      <div className='flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0'>
        <div
          className='fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity'
          aria-hidden='true'
          onClick={handler}
        ></div>

        <span className='hidden sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
          &#8203;
        </span>

        <div 
          className='inline-block align-bottom bg-white rounded-xl px-4 pt-5 pb-4 text-left overflow-hidden transform duration-75 sm:my-8 sm:align-middle sm:p-6'
          style={{ height: modelHeight, width: '36rem' }}
        >
          <div>
            <div className='flex flex-row-reverse'>
              <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={handler} />
            </div>
            <div className='mx-auto mt-3 flex items-center justify-center h-12 w-12 rounded-full bg-green-100'>
              <img src={icon} alt='modal icon' />
            </div>
            <div className='mt-8 text-center'>
              <h3 className='text-xl leading-6 text-gray-700' id='modal-title' style={{fontWeight : 700}}>
                {heading}
              </h3>
              <p className='text-base text-gray-600 w-11/12 m-auto mt-3'>{body}</p>
              <button 
                className={joinButtonClasses(dsButtonPrimary, 'm-auto mt-6 h-10 px-6', disableBtn && `${dsButtonDisabledPrimary} pointer-events-none`)}
                onClick={btnHandler}
              >
                {btnText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationSuccessModal;
